var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('docs-wrapper',{attrs:{"type":"learn","link":"","isHomepage":false,"title":_vm.pageTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }